import { AgentPortal } from '@wallet-manager/pfh-pmp-node-def-types';

import axios from '../axiosInstance';
import { IlistResult } from '../types';

const getAll = async (params: any, config?: any) => {
  const { pageSize, page, ...rest } = params;

  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get<any, IlistResult<any>>(
    AgentPortal.EptReport.creditAllocation.getAll,
    input
  );
};

const getExport = async (params: any, config?: any) => {
  const { pageSize, page, ...rest } = params;

  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };

  return await axios.get<any, IlistResult<any>>(
    AgentPortal.EptReport.creditAllocation.export,
    input
  );
};

const postRetry = async (params: any, config?: any) => {
  const input = {
    ...params,
    ...config,
  };

  return await axios.post<any, IlistResult<any>>(
    AgentPortal.EptReport.creditAllocation.retry,
    input
  );
};

export default { getAll, getExport, postRetry };
